import 'css-chunk:src/app/containers/GuestHome/Programs/GroupContentReviewPage/ContentDetails/components/Details/Details.module.scss';export default {
  "Details": "_Details_1jng9_1",
  "navigation": "_navigation_1jng9_6",
  "main": "_main_1jng9_27",
  "content": "_content_1jng9_33",
  "actions": "_actions_1jng9_38",
  "spinner": "_spinner_1jng9_41"
};